import { JoinOnCallRequester } from '~/domain/usecases/onCallRequester/remote';
import {
  NotFound,
  BadRequestError,
  Forbidden,
  UnexpectedError,
  BadGateway,
} from '~/domain/errors';
import { HttpClient, HttpStatusCode } from '~/data/protocols/http';
import '~/infra/global/variables';

export class RemoteJoinOnCallRequester implements JoinOnCallRequester {
  private readonly url: string;

  private readonly httpClient: HttpClient<JoinOnCallRequester.Model>;

  constructor(url: string, httClient: HttpClient<JoinOnCallRequester.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  join = async (
    params: JoinOnCallRequester.Params,
  ): Promise<JoinOnCallRequester.Model> => {
    const httpResponse = await this.httpClient.request({
      url: this.url
        .replace('{onCallId}', params.onCallId.toString())
        .replace('{requesterId}', params.requesterId.toString())
        .replace('{requestId}', params.requestId.toString()),
      method: 'post',
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.created:
      case HttpStatusCode.accepted:
      case HttpStatusCode.noContent:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      case HttpStatusCode.badGateway:
        throw new BadGateway();
      default:
        throw new UnexpectedError();
    }
  };
}
